import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from "react-router-dom";

export default function Card(props) {
  const {
    id,
    title,
    img,
  } = props;

  return (
    <CardContainer>
      <CardImageWrapper>
        <Link to={`/character/${ id }`}>
          <CardImage src={ img } alt={ title } />
        </Link>
      </CardImageWrapper>
      <CardContent>
        <Link to={`/character/${ id }`}>{ title }</Link>
      </CardContent>
    </CardContainer>
  );
}

Card.propTypes = {
  children: PropTypes.node,
};

const CardContainer = styled.div`
  background-color: #fff;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  color: #4a4a4a;
  max-width: 100%;
  position: relative;
`;

const CardImageWrapper = styled.figure`
  display: block;
  position: relative;
  padding-top: 75%;
  background: #dedede;
`

const CardImage = styled.img`
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
`

const CardContent = styled.div`
  background-color: #0000;
  padding: 1.5rem;
`
